<mat-list role="list">
    <mat-list-item role="listitem" *ngFor="let point of data.checklist" [class.active]="point.critical">
        {{ point.name}} - {{getStatus(point.status)}} {{getObs(point.obs)}} 
    </mat-list-item>
</mat-list>